import { ca } from '@cian/analytics';

export function trackOpenInfoAboutJK() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'open_info_about_JK',
    useLastProducts: true,
  });
}
